<template>
  <div class="hello">
    <h2>TestExport</h2>
    <hr />
    <h2>I am a remote vue compoent {{ msg }}</h2>
  </div>
</template>

<script>
  export default {
    name: 'TestExport',
    components: {},
    props: {
      msg: String,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>
